//The columnId is used as the sortingKey for the BE. These need to match what the BE expects
export const ColumnIds = {
  Name: 'name',
  AmendmentCount: 'amendmentCount',
  PayDate: 'payDate',
  MilestoneDueDateTimeUtc: 'milestoneDueDateTimeUtc',
  PayrunStatusId: 'payrunStatusId',
  PayrunStatusName: 'payrunStatusName',
  Company: 'companyName',
  BusinessUnitName: 'businessUnitName',
  AmendmentDueDateTimeUtc: 'amendmentDueDateTimeUtc',
  Assignee: 'assignee',
  Tags: 'tags',
  Actions: 'actions',
} as const;
export type ColumnIds = (typeof ColumnIds)[keyof typeof ColumnIds];

export type ColumnVisibility = Record<ColumnIds, boolean>;
